import api from './api';

// Create Stripe Checkout session
// Accepts either:
// - createCheckoutSession('price_...')
// - createCheckoutSession({ priceId?: string, returnUrl?: string, couponCode?: string })
export const createCheckoutSession = async (arg = undefined) => {
  try {
    let priceId;
    let returnUrl;
    let couponCode;
    if (typeof arg === 'string') {
      priceId = arg;
    } else if (arg && typeof arg === 'object') {
      priceId = arg.priceId;
      returnUrl = arg.returnUrl;
      couponCode = arg.couponCode;
    }

    const payload = {};
    if (priceId) payload.priceId = priceId;
    if (returnUrl) payload.returnUrl = returnUrl;
    if (couponCode) payload.couponCode = couponCode;

    const response = await api.post('/subscriptions/create-checkout', payload);
    return response.data;
  } catch (error) {
    console.error('Failed to create checkout session:', {
      error: error.message,
      response: error.response?.data
    });
    throw error;
  }
};

export const createPortalSession = async () => {
  try {
    const response = await api.post('/subscriptions/create-portal');
    return response.data;
  } catch (error) {
    console.error('Failed to create portal session:', {
      error: error.message,
      response: error.response?.data
    });
    throw error;
  }
};

export const getCurrentSubscription = async () => {
  try {
    // Avoid cached 304 by cache-busting param
    const response = await api.get(`/subscriptions/current?t=${Date.now()}`);
    return response.data;
  } catch (error) {
    console.error('Failed to get current subscription:', {
      error: error.message,
      response: error.response?.data
    });
    if (error.response?.status === 403 && error.response?.data?.requireVerification) {
      throw error;
    }
    return { subscription: null };
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await api.post('/subscriptions/cancel');
    return response.data;
  } catch (error) {
    console.error('Failed to cancel subscription:', {
      error: error.message,
      response: error.response?.data
    });
    throw error;
  }
};

export const reactivateSubscription = async () => {
  try {
    const response = await api.post('/subscriptions/reactivate');
    return response.data;
  } catch (error) {
    console.error('Failed to reactivate subscription:', {
      error: error.message,
      response: error.response?.data
    });
    throw error;
  }
};

export const verifySession = async (sessionId) => {
  try {
    const response = await api.post('/subscriptions/verify-session', { sessionId });
    return response.data;
  } catch (error) {
    console.error('Failed to verify session:', {
      error: error.message,
      response: error.response?.data
    });
    throw error;
  }
};
